import { render, staticRenderFns } from "./SKPPegawai.vue?vue&type=template&id=2206f45e&scoped=true&lang=html&"
import script from "./SKPPegawai.vue?vue&type=script&lang=js&"
export * from "./SKPPegawai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206f45e",
  null
  
)

export default component.exports